import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import faculty_1 from "../../image/newImg/4.jpg";
import faculty_2 from "../../image/newImg/2.jpg";
import faculty_3 from "../../image/newImg/3.jpg";
import faculty_m from "../../image/newImg/5.jpg";
// import faculty_3 from "../../image/newImg/3.png";
// import faculty_4 from "../../image/newImg/4.png";
// import faculty_5 from "../../image/newImg/5.png";
// import faculty_6 from "../../image/newImg/6.png";
import fsTopIcon from "../../image/newImg/fs.png";
import "./Content.css";
import ContentMain from "./ContentMain";
function Faculty(props) {
  const {
    cover,
    sidebar_data,
    data,
    title,
    alumni_data,
    curriculum_data,
    side_heading,
    side_sub_heading,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#0076BD" }}>
            <img
              src={fsTopIcon}
              style={{ width: "4rem", marginRight: "1rem" }}
            />
            Faculty & Staff
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                {/* <div className="f-bold f-1-2 mb-2"></div> */}
                <div className="color-grey f-500">
                  HGS Jammu has a very experienced,
                  knowledgeable, well-qualified and dedicated Staff, so much so
                  that they are conscious of their responsibility of being the
                  most important block in the foundation of the Nation as well
                  as the Society.
                </div>
                <div className="color-grey f-500 mt-2">
                  Their self-discipline is an example in itself, which always
                  drives them to work as a well-knit team to make all possible
                  endeavour together for the holistic growth of students as well
                  the institution. They are enthusiastic, dedicated,
                  conscientious and highly motivated to adapt to new innovative
                  ideas and well versed with modern education systems.
                </div>
                <div className="color-grey f-500 mt-2">
                  The valuable contribution of all the Faculty members is well
                  manifested in the spectacular achievements of our students in
                  the scholastic as well as co- scholastic discipline.
                </div>
                <div className="color-grey f-500 mt-2">
                  The Teachers grouped under various subject-wise Faculties are
                  put under the guidance of the most experienced Faculty heads.
                  All of them always put their heads together to devise
                  improvised methodology to deliver their best to facilitate the
                  young evolving minds. This significantly contributes in
                  promoting the problem solving skills of students to enable
                  them to grow as useful citizens.
                </div>
              </div>
            </div>
          </div>
          <div className="faculty_staff">
            <div className="">
              <div>
                <div className="f-bold f-1-2 mb-4 "></div>
                <div className="text-center">
                  <table className="table table-bordered table-striped table-hover align-middle mb-0">
                    <thead>
                      <tr className="section-row table-primary">
                        <td colSpan={4}>Teaching Staff (Confirmed)</td>
                      </tr>
                      <tr>
                        <th style={{ width: 80 }}>S.No</th>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Academic Qualification</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      <tr>
                        <td>1</td>
                        <td>Ms. Geeta Moza</td>
                        <td>PGT (Math)</td>
                        <td>M.Sc (Maths), B.Ed</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Ms. Nidhi Chaudhary</td>
                        <td>PGT (Bio)</td>
                        <td>M.Sc (Zoology), B.Ed</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Mr. Arvind Kumar Wali</td>
                        <td>PGT (Chem)</td>
                        <td>M.Sc (Chem.), B.Ed</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Ms. Nitanjeet Kour</td>
                        <td>PGT (Phy)</td>
                        <td>M.Sc (Electronics), B.Ed, CTET I</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Mr. Sandeep Thapar</td>
                        <td>PGT (Comm)</td>
                        <td>M.Com, B.Ed, PGDBM</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Mr. Puran Krishen Koul</td>
                        <td>PGT (Comp)</td>
                        <td>M.Sc IT, M.Tech</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Ms. Meenesh Kumar</td>
                        <td>PGT (Comm)</td>
                        <td>M.Com, B.Ed</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>Ms. Tamana</td>
                        <td>PGT (History)</td>
                        <td>M.A (Eng &amp; History), B.Ed, CTET-I</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Ms. Anu Chopra</td>
                        <td>PGT (Hindi)</td>
                        <td>M.A (Hindi), B.Ed</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Ms. Pamposh Mansotra</td>
                        <td>TGT (Maths)</td>
                        <td>B.Sc, B.Ed</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>Ms. Rekha Koul</td>
                        <td>TGT (Sc)</td>
                        <td>B.Sc, M.Ed</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>Mr. Rajinder Kumar Koul</td>
                        <td>TGT (Eng)</td>
                        <td>M.A (Eng), B.Ed, CTET II</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>Ms. Sangeeta Dhar</td>
                        <td>TGT (Sc)</td>
                        <td>B.Sc, M.Ed</td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>Mr. Shivashish Kaul</td>
                        <td>TGT (Fine Art)</td>
                        <td>BFA, PGD (Advt &amp; Public Relation)</td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>Ms. Sonali Mengi</td>
                        <td>TGT (Eng)</td>
                        <td>M.A (Eng), B.Ed, CTET I &amp; II</td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>Ms. Aarti Kapoor</td>
                        <td>TGT (Comp)</td>
                        <td>B.Sc, MCA, PGDIT</td>
                      </tr>
                      <tr>
                        <td>17</td>
                        <td>Ms. Harvinder Kour</td>
                        <td>TGT</td>
                        <td>B.A, M.Ed</td>
                      </tr>
                      <tr>
                        <td>18</td>
                        <td>Ms. Jyoti Raina</td>
                        <td>TGT</td>
                        <td>M.A (Hindi), B.Ed, C.P.Ed</td>
                      </tr>
                      <tr>
                        <td>19</td>
                        <td>Ms. Anita Tukra</td>
                        <td>PRT</td>
                        <td>B.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>20</td>
                        <td>Ms. Ranjni Pandita</td>
                        <td>PRT</td>
                        <td>B.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>21</td>
                        <td>Mr. Sunil Kumar Bhat</td>
                        <td>Comp. Tr.</td>
                        <td>10+2, DCPM</td>
                      </tr>
                      <tr>
                        <td>22</td>
                        <td>Ms. Sunita Raina</td>
                        <td>PRT</td>
                        <td>10+1, C.P.Ed</td>
                      </tr>
                      <tr>
                        <td>23</td>
                        <td>Ms. Dolly Bhat</td>
                        <td>PRT</td>
                        <td>B.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>24</td>
                        <td>Ms. Shafali Goma</td>
                        <td>PRT</td>
                        <td>M.A (Music)</td>
                      </tr>
                      <tr>
                        <td>25</td>
                        <td>Ms. Pushpa Singh</td>
                        <td>KGT</td>
                        <td>10+2, NTT</td>
                      </tr>
                      <tr>
                        <td>26</td>
                        <td>Ms. Veena Raina</td>
                        <td>PRT</td>
                        <td>B.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>27</td>
                        <td>Ms. Anjali Patwari</td>
                        <td>KGT</td>
                        <td>10+2, NTT</td>
                      </tr>
                      <tr>
                        <td>28</td>
                        <td>Ms. Lovely Koul</td>
                        <td>KGT</td>
                        <td>10+2, NTT</td>
                      </tr>
                      <tr>
                        <td>29</td>
                        <td>Ms. Harneet Kour</td>
                        <td>PRT</td>
                        <td>MCA, B.Ed, CTET I</td>
                      </tr>
                      <tr>
                        <td>30</td>
                        <td>Ms. Sukeshi Pandita Bhat</td>
                        <td>PRT</td>
                        <td>M.A (Eng), B.Ed</td>
                      </tr>
                      <tr>
                        <td>31</td>
                        <td>Ms. Ranu Koul</td>
                        <td>PRT</td>
                        <td>B.Sc, B.Ed, M.A Pub Adm, DOEAC A Level, CTET II</td>
                      </tr>
                      <tr>
                        <td>32</td>
                        <td>Ms. Meetu Sharma</td>
                        <td>KGT</td>
                        <td>B.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>33</td>
                        <td>Ms. Ragini Charak</td>
                        <td>PRT (Spl. Edu)</td>
                        <td>B.Sc, B.Ed, CTET I</td>
                      </tr>
                      <tr className="section-row table-success">
                        <td colSpan={4}>Non Teaching Staff</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Ms. Shakun Choudhary</td>
                        <td>Principal</td>
                        <td>M.Com, B.Ed</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Mr. Ashok Kumar Raina</td>
                        <td>Headmaster</td>
                        <td>B.Sc., M.A, B.Ed</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Mr. Rajinder Sharma</td>
                        <td>Sr. Co-worker - Admin</td>
                        <td>B.A, Dip. in Comp. Sc</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Mr. Naseer Ahmad Magray</td>
                        <td>Sr. Co-worker - Acctts</td>
                        <td>M.Com</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Mr. Ramesh Kumar Bhat</td>
                        <td>Lab Assistant</td>
                        <td>B.Sc</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Ms. Sneha Pandita</td>
                        <td>Office Asstt</td>
                        <td>MBA</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Ms. Babita Kharihaloo</td>
                        <td>Asstt. Librarian</td>
                        <td>M.Lib</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>Mr. Kamal Gupta</td>
                        <td>Jr. Coworker - Maint</td>
                        <td>B.A, ITI</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Mr. Ved Kumar Sharma</td>
                        <td>Driver</td>
                        <td>9th Pass</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Mr. Ganesh Sharma</td>
                        <td>Helper</td>
                        <td>7th Pass</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>Mr. Romesh Kumar</td>
                        <td>Jr. Coworker Acctts.</td>
                        <td>B.A</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>Mr. Des Raj</td>
                        <td>Helper</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>Mr. Jeevan Lal</td>
                        <td>Helper / Sweeper</td>
                        <td>-</td>
                      </tr>
                      <tr className="section-row table-warning">
                        <td colSpan={4}>Probation / Contractual / Part Time Staff</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Ms. Navika Gupta</td>
                        <td>PGT (Pol Sc)</td>
                        <td>M.A (Pol Sc), B.Ed</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Ms. Muskan Rajput</td>
                        <td>PGT (PE)</td>
                        <td>M.P.Ed</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Ms. Amrita Boghia</td>
                        <td>TGT S.Sc</td>
                        <td>M.A (History), B.Ed</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Mr. Reviti Nandan</td>
                        <td>TGT (PE)</td>
                        <td>M.P.Ed</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Ms. Jyoti</td>
                        <td>TGT (Maths)</td>
                        <td>B.Sc, B.Ed, CTET II</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Ms. Archana Sharma</td>
                        <td>TGT (Hindi)</td>
                        <td>M.A (Hindi), B.Ed</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Ms. Somam</td>
                        <td>TGT</td>
                        <td>M.A (Sanskrit), B.Ed</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>Mr. Sanjeev Mangotra</td>
                        <td>TGT Dance</td>
                        <td>B.A (Kathak)</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>Ms. Neelam Sharma</td>
                        <td>PRT</td>
                        <td>M.A, B.Ed, CTET I</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>Ms. Shalini Dutta</td>
                        <td>PRT</td>
                        <td>M.A (Eng), B.Ed, CTET I</td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>Mr. Puran Krishen Kotwal</td>
                        <td>Band Master</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Faculty;
